/**
 * <s-share-link> — the "send" share button. Opens the phone's share sheet when
 * available (Messages, WhatsApp, email…), otherwise copies the product link and
 * briefly shows the "Link copied" note.
 */
class SShareLink extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.button = this.querySelector('button');
    this.note = this.querySelector('[data-share-copied]');
    this.button?.addEventListener('click', () => this.#share(), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch (error) {
        // The shopper closed the share sheet; nothing to do.
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      if (this.note) {
        this.note.hidden = false;
        setTimeout(() => { this.note.hidden = true; }, 2000);
      }
    } catch (error) {
      window.prompt(title, url);
    }
  }
}

if (!customElements.get('s-share-link')) {
  customElements.define('s-share-link', SShareLink);
}
